import { LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Col, Dropdown, Menu, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DarkModeSwitch } from "react-toggle-dark-mode";
import getUserFromToken from "../../utils/getUserFromToken";
import styles from "./Header.module.css";
import appleStoreImage from "../../assets/appleStore.png";
import playStoreImage from "../../assets/playStore.webp";
const toggler = [
	<svg
		width='20'
		height='20'
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 448 512'
		key={0}>
		<path d='M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z'></path>
	</svg>,
];

function Header({ onPress, collapsed, handleCollapsed }) {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const isLogged = localStorage.getItem("isLogged");
	const user = localStorage.getItem("user");
	const userId = getUserFromToken();


	// console.log("user in header", user)

	const items = [
		{
			key: "1",
			label: (
				<p
					style={{ margin: 0, padding: "0.2rem 0.5rem" }}
					className='flex align-items-center p-0.5'>
					<Link to={`/admin/hr/staffs/${userId}`}>
						<UserOutlined style={{ fontSize: "16px" }} />{" "}
						<span className='logout-text font-weight-bold me-2 ms-1'>{user}</span>
					</Link>

				</p>
			),
		},
		{
			key: "2",
			label: (
				<p
					style={{ margin: 0, padding: "0.2rem 0.5rem" }}
					className='flex align-items-center'>
					<Link to='/admin/auth/logout' className={styles.logoutLink}>
						<LogoutOutlined className='text-danger' />
						<span className='logout-text font-weight-bold'>Log Out</span>
					</Link>
				</p>
			),
		},
	];

	const [isDarkMode, setDarkMode] = useState(false);

	const toggleDarkMode = (checked) => {
		setDarkMode(checked);
	};

	useEffect(() => {
		if (isDarkMode) document.body.className = "dark-theme";
		if (!isDarkMode) document.body.className = "light-theme";
	}, [isDarkMode]);

	const downloadFile = (url) => {
		const link = document.createElement("a");
		link.href = url;
		link.target = "_blank";
		link.download = "";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	
	const handleDownloadUserApp = () => {
		downloadFile("/MobileAppApk/app-release.apk");
	  };
	
	  const handlePlayStoreClick = () => {
		window.open("https://play.google.com/store/apps/details?id=com.softomation.hrms_project", "_blank");
	  };
	
	  const handleAppleStoreClick = () => {
		window.open("https://apps.apple.com/in/app/hrm360-uk-employee-app/id6755679477", "_blank");
	  };

	return (
		<>
			<Row gutter={[24, 0]}>
				<Col span={24} md={4}>
					<div className={styles.sidebarTogglerPC}>
						{isLogged &&
							React.createElement(
								collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
								{
									className: `${styles.trigger}`,
									onClick: () => handleCollapsed(!collapsed),
								}
							)}
					</div>
				</Col>
				<Col span={24} md={20} className={styles.headerControl}>
					{/* <Button
						type="primary"
						icon={<DownloadOutlined />}
						className="download-btn"
						onClick={handleDownloadUserApp}
					>
						HRM App
					</Button> */}
					 {isLogged && (
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <img
                src={playStoreImage}
                alt="Play Store"
                onClick={handleDownloadUserApp}
                style={{
                  height: "40px",
                  cursor: "pointer",
                  borderRadius: "4px",
                  transition: "transform 0.2s ease-in-out"
                }}
                onMouseOver={(e) => e.target.style.transform = "scale(1.05)"}
                onMouseOut={(e) => e.target.style.transform = "scale(1)"}
              />
              <img
                src={appleStoreImage}
                alt="Apple Store"
                onClick={handleAppleStoreClick}
                style={{
                  height: "40px",
                  cursor: "pointer",
                  borderRadius: "4px",
                  transition: "transform 0.2s ease-in-out"
                }}
                onMouseOver={(e) => e.target.style.transform = "scale(1.05)"}
                onMouseOut={(e) => e.target.style.transform = "scale(1)"}
              />
            </div>
          )}
					<DarkModeSwitch
						style={{ margin: "1rem" }}
						checked={isDarkMode}
						onChange={toggleDarkMode}
						size={20}
					/>

					{/* {isLogged && (
            <Typography.Title
              level={5}
              style={{ margin: 0 }}
              className="me-3 flex align-items-center"
            >
              <UserOutlined style={{ fontSize: "16px" }} />{" "}
              <span className="logout-text font-weight-bold me-2 ms-1">
                {user}
              </span>
            </Typography.Title>
          )} */}

					{!isLogged && (
						<Link to='/admin/auth/login' className='btn-sign-in text-dark'>
							<span></span>
						</Link>
					)}

					{isLogged && (
						<Button
							type='link'
							className={styles.sidebarTogglerMobile}
							onClick={() => onPress()}
							style={{ boxShadow: "none" }}>
							{toggler}
						</Button>
					)}
					{isLogged && (
						<div>
							<Dropdown
								overlay={<Menu items={items} />}
								placement='bottomLeft'
								className='user-dropdown'>
								<Button className='user-btn'>
									<UserOutlined style={{ fontSize: "16px" }} />
								</Button>
							</Dropdown>
						</div>
					)}
				</Col>
			</Row>
		</>
	);
}

export default Header;
